<script lang="ts" setup>
import { defineAsyncComponent, onMounted } from 'vue';
import LayoutMain from 'Layouts/LayoutMain.vue';
import { dispatchRenderReady } from 'Pages/utils/render';
import { useLoginRedirectDefault } from 'Composables/useLoginRedirectDefault';
import ControlRender from '@/components/ControlRender/ControlRender.vue';
import BaseSkeleton from 'Components/Base/BaseSkeleton';
import { usePageSeo } from '../сomposables';

import ContentHomeHeader from './components/ContentHomeHeader.vue';
import ContentHomeTrackrecord from './components/ContentHomeTrackrecord.vue';

const ContentHomeWhyFarmland = defineAsyncComponent({
  loader: () => import(/* webpackChunkName: 'ContentHomeWhyFarmland' */ './components/ContentHomeWhyFarmland.vue'),
  loadingComponent: BaseSkeleton,
});
const ExitedInvestmentsSlider = defineAsyncComponent({
  loader: () => import(/* webpackChunkName: 'ExitedInvestmentsSlider' */ 'Components/ExitedInvestmentsSlider/ExitedInvestmentsSlider.vue'),
  loadingComponent: BaseSkeleton,
});
const ContentHomeWhyAcreTrader = defineAsyncComponent({
  loader: () => import(/* webpackChunkName: 'ContentHomeWhyAcreTrader' */ './components/ContentHomeWhyAcreTrader.vue'),
  loadingComponent: BaseSkeleton,
});
const ContentHomeHowItWorks = defineAsyncComponent({
  loader: () => import(/* webpackChunkName: 'ContentHomeHowItWorks' */ './components/ContentHomeHowItWorks'),
  loadingComponent: BaseSkeleton,
});
const ContentHomeForFarmers = defineAsyncComponent({
  loader: () => import(/* webpackChunkName: 'ContentHomeForFarmers' */ './components/ContentHomeForFarmers.vue'),
  loadingComponent: BaseSkeleton,
});
const ContentHomeAboutInvestingFarmland = defineAsyncComponent({
  loader: () => import(/* webpackChunkName: 'ContentHomeAboutInvestingFarmland' */ './components/ContentHomeAboutInvestingFarmland.vue'),
  loadingComponent: BaseSkeleton,
});
const ContentHomeReadyToGetStarted = defineAsyncComponent({
  loader: () => import(/* webpackChunkName: 'ContentHomeReadyToGetStarted' */ './components/ContentHomeReadyToGetStarted.vue'),
  loadingComponent: BaseSkeleton,
});

const { setPageTitle } = usePageSeo();

onMounted(() => {
  setPageTitle();
  setTimeout(() => dispatchRenderReady(), 10000);
});

async function onPopupLoggedIn() {
  await useLoginRedirectDefault().redirectOnLoginDefault();
}

</script>

<template>
  <div class="PageHome">
    <LayoutMain
      redirect-on-login="default"
      @popup-logged-in="onPopupLoggedIn"
    >
      <div class="content-home">
        <ContentHomeHeader />
        <ContentHomeTrackrecord class="content-home__trackrecord" />
        <div
          class="content-home__container"
          :style="{ minHeight: '1000px' }"
        >
          <ControlRender
            when-visible
            :timeout="5000"
            when-prerender
            visibility-top-margin="600px"
          >
            <ContentHomeWhyFarmland />
          </ControlRender>
        </div>
        <div
          class="content-home__container content-home__exited-slider"
          :style="{ minHeight: '750px' }"
        >
          <ControlRender
            when-visible
            :timeout="5000"
            when-prerender
            visibility-top-margin="600px"
          >
            <ExitedInvestmentsSlider />
          </ControlRender>
        </div>
        <div
          class="content-home__container"
          :style="{ minHeight: '600px' }"
        >
          <ControlRender
            when-visible
            :timeout="5000"
            when-prerender
            visibility-top-margin="600px"
          >
            <ContentHomeWhyAcreTrader />
          </ControlRender>
        </div>
        <div
          class="content-home__container"
          :style="{ minHeight: '1100px' }"
        >
          <ControlRender
            when-visible
            :timeout="5000"
            when-prerender
            visibility-top-margin="600px"
          >
            <ContentHomeHowItWorks />
          </ControlRender>
        </div>
        <div
          class="content-home__container"
          :style="{ minHeight: '650px' }"
        >
          <ControlRender
            when-visible
            :timeout="5000"
            when-prerender
            visibility-top-margin="600px"
          >
            <ContentHomeForFarmers />
          </ControlRender>
        </div>
        <div
          class="content-home__container"
          :style="{ minHeight: '550px' }"
        >
          <ControlRender
            when-visible
            :timeout="5000"
            when-prerender
            visibility-top-margin="600px"
          >
            <ContentHomeAboutInvestingFarmland />
          </ControlRender>
        </div>
        <div
          class="content-home__container"
          :style="{ minHeight: '300px' }"
        >
          <ControlRender
            when-visible
            :timeout="5000"
            when-prerender
            visibility-top-margin="600px"
          >
            <ContentHomeReadyToGetStarted />
          </ControlRender>
        </div>
      </div>
    </LayoutMain>
  </div>
</template>

<style lang="sass" scoped>
@import '~Styles/_variables'
.content-home
  padding-bottom: 110px
  margin-top: -115px
  padding-top: 115px
  background-color: $alabaster
  overflow: hidden
  position: relative
  &__trackrecord
    margin-bottom: 48px
  &__exited-slider
    margin-top: 110px
    margin-bottom: 105px
    @media screen and (max-width: 767px)
      margin-bottom: 100px
      margin-top: 100px
  &__are-you-an-advisor
    width: 100%
    max-width: 1170px
    padding: 0 15px
    margin: 0 auto
    margin-bottom: 110px
    @media screen and (max-width: 767px)
      margin-bottom: 100px
  &__container
    display: grid
    :deep(.placeholder-loading)
      height: 100% !important
</style>
